var $5c5477c2e2e66a16$exports = {};
$5c5477c2e2e66a16$exports = {
    "actions": `Aktionen`,
    "hideButtonLabel": `Weniger zeigen`,
    "noTags": `Keine`,
    "showAllButtonLabel": (args, formatter)=>`Alle anzeigen (${formatter.number(args.tagCount)})`
};


export {$5c5477c2e2e66a16$exports as default};
//# sourceMappingURL=de-DE.mjs.map
